export const ideasPrivateRoutesConstants = {
  root: {
    path: "/r/app/ideas",
    href: (projectId: string) => `/r/app/ideas?project=${projectId}`
  }
} as const;
